import ProgressGraphs from './ProgressGraphs'

export default ProgressGraphs